import script from "./cBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./cBtn.vue?vue&type=script&setup=true&lang=js"

import "./cBtn.vue?vue&type=style&index=0&id=2a8dd462&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a8dd462"]])

export default __exports__